/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./card.vue?vue&type=template&id=08327630&"
import script from "./card.vue?vue&type=script&setup=true&lang=ts&"
export * from "./card.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./card.vue?vue&type=style&index=0&id=08327630&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports